// extracted by mini-css-extract-plugin
export default {"container":"LLMIndicator_container__evNrm","icon":"LLMIndicator_icon__mjRhY","truncate":"LLMIndicator_truncate__0Hm5X"};